import { IonAccordion, IonAccordionGroup, IonAvatar, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSkeletonText, IonSpinner, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { add, addCircleOutline, addOutline, carOutline, informationCircle } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

const Vehicles: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, setShowLoader, limits, profiles, settings, vehicles, getVehicles, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo, textLogoLoaded, fadeInTextLogo } = useAppContext();
    
    const router = useIonRouter();

    const vehiclePhotoPath = '//api.besolowise.com/vehicles/photos/files/'; 

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();             
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            }
        };
        authenticate();
    }); 


    useEffect(() => {
        if (limits.vehicles > 0) {
            const fetchData = async () => {
                await getVehicles(authorizedMember.memberToken, limits.vehicles);
                window.setTimeout(() => {
                    setShowLoader(false);
                }, 2000);
            }
            fetchData();
        }
    }, [authorizedMember, limits]);


    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setLoading(true);
        setTimeout(async () => {
            await getVehicles(authKey.mt, limits.vehicles);
            event.detail.complete();
            setLoading(false);
        }, 2000);
    };

    const toggleAlertContent = () => setAlertVisible(!alertVisible);

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id="Vehicles">

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='7'>
                            <h1><IonIcon color={'secondary'} icon={carOutline}></IonIcon> My Vehicles<br /><span>Manage your saved vehicles</span></h1>
                        </IonCol>
                        <IonCol className='ion-margin-bottom top-action-button'  size='12' sizeSm='5'>                            
                            {profiles?.vehicles < limits?.vehicles &&             
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/vehicle/create' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Add a New Vehicle</IonButton>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonAccordionGroup className='ion-margin'>
                    <IonAccordion value="info">
                        <IonItem slot='header' color={'light'}>
                            <IonLabel><IonIcon color={'tertiary'} icon={informationCircle} size='large'></IonIcon> What is a SoloWise Vehicle?</IonLabel>
                        </IonItem>
                        <div slot="content">                
                            <IonCard>
                                <IonCardContent>
                                     A <strong>SoloWise Vehicle</strong> can be a car, truck, motorcycle, bicycle, ATV, snowmobile, kayak, canoe, airplane, you name it &mdash; anything that you're traveling in or on during a SoloWise Timer.
                                </IonCardContent>
                            </IonCard>
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>

                {vehicles.length > 0
                    ? <>
                        {vehicles.map((vehicle:any, index:number) => (                    
                        <IonCard key={index} routerDirection='forward' routerLink={`/account/vehicle/edit/${vehicle.vehicleToken}`}>
                            <IonCardContent className='ion-no-padding'>
                                <IonItem lines='none'>
                                    {vehicle.vehiclePhoto == ''|| vehicle.vehiclePhoto == null
                                            ? <InitialsAvatar className='initials-avatar' name={`${vehicle.vehicleMfg}`} />  
                                            : <IonAvatar slot='start'><IonImg src={vehicle.vehiclePhotoThumbnailUrl} /></IonAvatar>
                                    }   
                                    <IonLabel>
                                        <h2>{vehicle.vehicleYear} {vehicle.vehicleMfg}</h2> 
                                        <p>{vehicle.vehicleModel}</p>
                                    </IonLabel>
                                </IonItem>
                            </IonCardContent>
                        </IonCard>                    
                        ))}
                        {profiles?.vehicles >= limits?.vehicles &&
                            <IonCard>
                                <IonCardHeader>
                                    <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                                        You've reached the limit of Vehicles for your current plan.
                                    </IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <p className='ion-margin-bottom ion-text-center'>
                                        You can add more Vehicles by upgrading to a SoloWise Premium plan. 
                                    </p>
                                    <p className='ion-margin-bottom ion-text-center'>                            
                                        <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                                    </p>
                                </IonCardContent>
                            </IonCard>
                        } 
                      </>
                    :<p className='ion-text-center'>You have no recorded SoloWise Vehicles.</p>
                }
            </IonContent>
        </IonPage>
    );
};

export default Vehicles;